<template>
    <div>
        <Spin size="large" fix v-if="spinShow"></Spin>
    </div>
</template>

<script>
    export default {
        props:{
            spinShow:{
                type:Boolean,
                default:true
            }
        }
        
    }
</script>